import { initialDataParser } from "@kano/utilities/initialData";
import { i18n, initPublicMessages } from '@kano/i18n';
import Vue from "vue";
import ProfitCalculatorApp from "@kano/components/ProfitCalculator/ProfitCalculatorApp.vue";
import { ProfitCalculatorProps } from "@kano/types/profit-calculator";

async function init(props: ProfitCalculatorProps) {
  await initPublicMessages();

  new Vue({
    i18n,
    render: h => h(ProfitCalculatorApp, {
      props,
    }),
  }).$mount('#profit-calculator-app');
};

const { props } = initialDataParser(
  'profitCalculator',
  ['props'],
);

init(props);